import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import moment from 'moment';

@Injectable({
  providedIn: 'root'
})
export class CBOPaymentsService
{
  constructor(private http: HttpClient) { }

  public getCBOPaymentsList(organizationIds: any[], from: Date, to: Date, orgPaymentStatusIds: number): Observable<any>
  {
    return this.http.get(`/cbo/payment/list?organizationIds=${organizationIds.join()}&from=${moment(from).format('YYYY-MM-DD').toString()}&to=${moment(to).format('YYYY-MM-DD').toString()}&orgPaymentStatusIds=${orgPaymentStatusIds}`);
  }

  public updateOrgPaymentStatus(orgPaymentStatusId: number, data: any[]): Observable<any>  // updates Org Payment Status for multiple case billable records at once
  {
    return this.http.put(`/cbo/payment/billable/${orgPaymentStatusId}`, data);
  }
}
